import React from 'react';
import { useMst } from '../model/Root';
import { observer } from 'mobx-react-lite';
import { Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import Notification from './Notification';
import { Box, CircularProgress, Container, Grid, Typography } from '@mui/material';
import { color } from 'theme';

interface LayoutProps {
  title: string;
  children: React.ReactNode;
  fullWidth?: boolean;
}

const Layout = observer((props: LayoutProps) => {
  const {
    userStore: { token, user, userLogout, state: authState },
    errorStore: { error, clearError, success },
  } = useMst();
  const { children, title, fullWidth } = props;

  const onLogout = () => {
    userLogout();
    return <Navigate to="/login" />;
  };

  // Redirect to login if there is no token or no user after auth resolution
  if (!token) {
    return <Navigate to="/login" />;
  }

  const authResolving = authState === 'IN_PROGRESS';

  if (authResolving) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If auth is resolved but user is missing, fail safe to login
  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <Container maxWidth={false} style={{ padding: 0 }}>
      <Grid container>
        <Header user={user} logoutHandler={onLogout} />
        <Grid container item style={{ backgroundColor: color.grayBackground, maxWidth: 280, minWidth: 280 }}>
          <Sidebar />
        </Grid>
        <Grid container item xs={fullWidth ? 9 : 8} mt={2} alignContent={'flex-start'}>
          <Grid item xs={12} ml={4} mb={4}>
            <Typography variant="h3">{title}</Typography>
          </Grid>
          <Grid item xs={12} ml={4}>
            {children}
          </Grid>
          <Notification error={error} success={success} onClose={clearError} />
        </Grid>
      </Grid>
    </Container>
  );
});

export default Layout;
